/**
 * Whose profile a talent page shows (spec 1.8: My info and Sharing, the RecordSwitcher), PURE and shared: a login
 * controls its own record and the records of the dependents it manages, and each page shows one of them.
 */
/** A record's name on the switcher: the user's own is marked as theirs. */
export const recordLabel = (r) => (r.kind !== 'self' ? r.name : r.name && r.name !== 'You' ? `${r.name} (you)` : 'You');
/** Whose profile a page shows, as its frame names it: "Your profile", or a dependent's by name ("Emma's profile"). */
export const profileOwnerLabel = (r) => r?.kind === 'dependent' ? `${r.name.trim() || 'Your child'}'s profile` : 'Your profile';
/**
 * Which record a page shows. `record`: the page's `?record=`. `client`: the agency row the page names instead (an agency's
 * page and a notice link so), with `resolved`, the record the server resolved that row to among the user's (undefined
 * while it is being looked up, null when the row is none of theirs). A link that names a record or a row that matches
 * none of the user's records is never guessed at: the page asks whose profile to show. With nothing named, the user's
 * own record, else the first.
 */
export function chooseRecord(records, want) {
    if (!records.length)
        return { kind: 'none' };
    if (want.record) {
        const named = records.find((r) => r.id === want.record);
        return named ? { kind: 'record', record: named } : { kind: 'choose' };
    }
    if (want.client) {
        if (want.resolved === undefined)
            return { kind: 'resolving' };
        const owner = want.resolved ? records.find((r) => r.id === want.resolved) : undefined;
        return owner ? { kind: 'record', record: owner } : { kind: 'choose' };
    }
    const fallback = records.find((r) => r.kind === 'self') ?? records[0];
    return fallback ? { kind: 'record', record: fallback } : { kind: 'none' };
}
/**
 * What a talent page does before it shows (spec 1.8): the signed-in user's details say whether the consent UI is on, so
 * until they are in it waits (a reload or a notice's link never bounces home early); then it shows, or with the switch
 * off it goes home (these pages do not exist then).
 */
export function talentPageGate(me) {
    if (!me)
        return 'wait';
    return me.features?.consentUi === true ? 'show' : 'home';
}
//# sourceMappingURL=records.js.map